export interface Tab {
    id: number;
    component: JSX.Element;
    roles: string[];
}

export interface Categories {
    [key: string]: Tab[];
}

export const filterTabsByRole = (categories: Categories, userRole: string): Categories => {
    const filteredCategories: Categories = {};

    Object.keys(categories).forEach((key) => {
        const tab = categories[key][0]; 
        if (tab.roles.includes(userRole)) {
            filteredCategories[key] = [tab];
        }
    });

    return filteredCategories;
};